import { Status, TextLink } from '@mm/components';
import { UICampaignItem } from '@mm/state/reducers/campaignsOverview';
import { activeFacebookPagePlanInfoSelector } from '@mm/state/selectors/facebookPageSelector';
import { selectAudienceByIdOrIds } from '@mm/state/selectors/messengerAdSelectors';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import React from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { ThreeDotMenu } from '../../../../../../../common/components/ThreeDotMenu/ThreeDotMenu';
import { formatDateTime } from '../../../../../../../common/helpers/formatDateTime';
import { trackWebAppGAEvent } from '../../../../../../../common/helpers/plugins/website-google-analytics';
import { useDeleteCampaign } from '../../use-delete-campaign';
import { EntityRowBaseTemplate } from '../EntityRowBaseTemplate';
import { CampaignBaseInfo, Kind } from '../SharedCells';
import { BotBuilderRoutes } from '../../../../../../../routes/bot-builder-routes';

export type UISponsoredMessagesStatusType = 'Draft' | 'Published';

export const SponsoredMessageRow = ({ item }: { item: UICampaignItem }) => {
  const { history } = useRouter();
  const activeChatbotId = useSelector(activeChatbotIdSelector);
  const isFree = useSelector(activeFacebookPagePlanInfoSelector).info
    ?.isFreeOrSpecialPlan;

  const audiencesIds = item.audiences?.map(id => parseInt(id, 10));
  const audiences = useSelector((state: StoreState) =>
    selectAudienceByIdOrIds(state, audiencesIds || []),
  );

  const audiencesNames = audiences.map(({ name }) => name).join(',');

  const bottomText = audiencesNames && `Audiences: ${audiencesNames}`;
  const subHeadingText =
    item.adAccountName &&
    `Ad account name: ${item.adAccountName} ${item.adAccountId}`;

  const startDate = item.adSetStartDate
    ? `Start date: ${formatDateTime(item.adSetStartDate)}`
    : '';

  const status = item.draft ? 'Draft' : isFree ? 'Paused' : 'Published';

  const navigateToEditRoute = () => {
    const path = BotBuilderRoutes.sponsoredMessagesEdit.getLink({
      chatbotId: activeChatbotId,
      id: item.id,
    });
    history.push(path);
  };

  const onRowClick = () => {
    trackWebAppGAEvent('click', {
      category: 'campaigns_table',
      label: `table_item_sponsored_message`,
    });
    navigateToEditRoute();
  };

  const { deleteCampaign } = useDeleteCampaign();
  const onSelectItem = (menuItem: string) => {
    switch (menuItem) {
      case 'edit':
        trackWebAppGAEvent('click', {
          category: 'campaigns_table',
          label: `edit_button_sponsored_message`,
        });
        return navigateToEditRoute();
      case 'delete':
        return deleteCampaign(item);
      default:
        break;
    }
  };

  const elements = [
    { name: 'Edit', value: 'edit' },
    { name: 'Delete', value: 'delete' },
  ];

  const onMenuClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <EntityRowBaseTemplate
      className="starters-table__data-row starters-table__data-row--large"
      onClick={onRowClick}
      inactive={status === 'Draft'}
    >
      <CampaignBaseInfo
        headingText={item.name}
        subHeadingText={subHeadingText}
        bottomText={bottomText}
      />
      <Kind kind="sponsored_messages" />

      <TextLink>{startDate}</TextLink>

      <Status status={status} />

      <span />
      <span />
      <span />

      {/*      <CountWithTitle count="?" text="Sent" />

      <CountWithTitle count="?" text="Responded" />*/}

      <ThreeDotMenu
        className="shared_cells__menu"
        onClick={onMenuClick}
        elements={elements}
        selectItem={onSelectItem}
      />
    </EntityRowBaseTemplate>
  );
};
